// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * states that a module can have with lecturers: draft > published
 */
export type ModuleWorkflowState = (typeof ModuleWorkflowState)[keyof typeof ModuleWorkflowState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleWorkflowState = {
  draft: 'draft',
  published: 'published',
} as const;
